import {
  Button,
  Col,
  Form,
  message,
  Row,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect } from "react";
import "./BillboardEnquiryModal.css";
import FloatingInput from "../../common/float-input/FloatInput";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import { userQueryPost } from "../../../store/thunks/common-thunks/commonThunk";
import { useDispatch, useSelector } from "react-redux";
import { RESET_ADV } from "../../../store/slices/auth/BillboardEnquirySlice";
const { Text } = Typography;
const BillboardEnquiry = ({ form, setBillboardModal }) => {
  const dispatch = useDispatch();
  const { isLoading, status } = useSelector((state) => state.billboardEnquiry);
  const { addStatus, updateAdvResult } = useSelector(
    (state) => state.billboardEnquiry
  );

  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--input-width": "12px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };

  useEffect(() => {
    if (status === "success") {
      message.success("Submitted successfully!");
    } else if (status === "failed") {
      message.error("Failed to submit...!");
    }
  }, [isLoading, status]);

  const handleRequst = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("email", values.email);
    formData.append("subject", values.subject);
    formData.append("contactno", values.contactno);
    formData.append("message", values.message);

    dispatch(userQueryPost(formData));
  };
  useEffect(() => {
    if (addStatus === "success") {
      if (updateAdvResult) {
        message.success(updateAdvResult || "Submitted Succesfully....");
        form.resetFields();
        setBillboardModal(false);
        dispatch(RESET_ADV());
      }
    } else if (addStatus === "failed") {
      message.error("Please try again !!!");
      setBillboardModal(false);
      dispatch(RESET_ADV());
    }
  }, [addStatus]);

  return (
    <div style={{ paddingTop: "30px" }}>
      <Form form={form} onFinish={handleRequst}>
        <div>
          <Row className="disable-flex">
            <Text className=" billboard-quote-row quote-in-minute ">
              Get Your Product Quote in Minutes!
            </Text>
          </Row>
          <Row>
            <Text className="ready-to-make-text">
              Ready to make a big impact with your next campaign? Tell us what
              you need, and we'll provide a customized quote tailored to your
              goals.
            </Text>
          </Row>
          <Row gutter={[16, 16]} className="billbaord-enquiry-quote-row">
            <Col span={12}>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Full name is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Full Name `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: "Email is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Email`}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: "10px" }}>
            <Col span={12}>
              <Form.Item
                name="subject"
                rules={[
                  {
                    required: true,
                    message: "Subject type is required!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild "
                  border={false}
                  popupClassName="billboard-select-dropdown"
                  label={
                    <>
                      {`Subject Type `}
                      {star}
                    </>
                  }
                  options={[
                    { id: "pricing", name: "Pricing" },
                    {
                      id: "request-demo",
                      name: "Request a Demo",
                    },
                    { id: "buyer-assistance", name: "Buyer Assistance" },
                    { id: "seller-assistance", name: "Seller Assistance" },
                    { id: "media-inquiries", name: "Media Inquiries" },
                    { id: "billing-accounting", name: "Billing/Accounting" },
                    { id: "rfp-status", name: "RFP Status" },
                    { id: "api-documentaion", name: "API Documentation" },
                    { id: "other", name: "Other" },
                  ]}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="contactno"
                rules={[
                  {
                    required: true,
                    message: "Phone Number is required!",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "Phone number must be exactly 10 digits",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Phone Number`}
                      {star}
                    </>
                  }
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="enquiry-form-item-css">
            <Form.Item
              name="message"
              rules={[
                {
                  required: true,
                  message: "Message is required!",
                },
              ]}
              style={{ width: "100%" }}
            >
              <FloatingTextArea
                customStyles={textAreaFloatingInputStyles}
                label={
                  <>
                    {`Message`}
                    {star}
                  </>
                }
                showCount
                maxLength={600}
                className="billboard-input-feild billboard-text-area"
              ></FloatingTextArea>
            </Form.Item>
          </Row>

          <Row className="request-my-quote">
            <Button
              type="primary"
              htmlType="submit"
              className="request-my-demo-btn-billboard-enquiry billboard-button-2"
            >
              Request My Quote
            </Button>
          </Row>
          <Row gutter={[16, 16]} className="we-respect-privacy-row">
            <Text className="respect-privacy-text">
              We respect your privacy. Your information will only be used to
              provide a quote and will not be shared.
            </Text>
          </Row>
        </div>
      </Form>
      {isLoading && (
        <div className="request-my-demo-btn-billboard-enquiry-spin">
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};
export default BillboardEnquiry;
